export default __webpack_public_path__ + "static/media/CNo.26-1.dc98839e.jpg";